import React from 'react';
import { FaUser, FaChevronDown, FaShoppingBag } from 'react-icons/fa';
import { User } from '../../types/auth';

interface UserDropdownProps {
  userInfo: User;
  dropdownOpen: boolean;
  setDropdownOpen: (open: boolean) => void;
  dropdownRef: React.RefObject<HTMLDivElement | null>;
  onBuyTicket: () => void;
  onProfileSettings: () => void;
  onViewOrders: () => void;
  onLogout: () => void;
}

const UserDropdown: React.FC<UserDropdownProps> = ({
  userInfo,
  dropdownOpen,
  setDropdownOpen,
  dropdownRef,
  onBuyTicket,
  onProfileSettings,
  onViewOrders,
  onLogout,
}) => {
  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex items-center gap-2 bg-gray-50 px-5 py-2 rounded-xl hover:bg-gray-100 transition border border-gray-200 min-w-[162px] shadow"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <FaUser className="text-gray-500" />
        <div className="flex flex-col items-start text-left">
          <span className="text-gray-800 font-semibold leading-tight">
            {userInfo.name} {userInfo.surname}
          </span>
          <span className="text-xs text-gray-400 leading-tight">{userInfo.management}</span>
        </div>
        <FaChevronDown
          className={`ml-2 text-gray-400 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`}
        />
      </button>
      {dropdownOpen && (
        <div className="absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-xl shadow-xl z-50 animate-fadeIn">
          <button
            className="w-full flex items-center gap-2 px-5 py-3 text-base text-blue-700 hover:bg-blue-50 transition rounded-t-xl"
            onClick={onBuyTicket}
          >
            <span className="font-semibold">Fiş Satın Al</span>
          </button>
          <button
            className="w-full flex items-center gap-2 px-5 py-3 text-base text-green-700 hover:bg-green-50 transition border-t border-gray-100"
            onClick={onViewOrders}
          >
            <FaShoppingBag className="text-green-600" />
            <span className="font-semibold">Siparişlerim</span>
          </button>
          <button
            className="w-full flex items-center gap-2 px-5 py-3 text-base text-gray-700 hover:bg-gray-100 transition border-t border-gray-100"
            onClick={onProfileSettings}
          >
            <span className="font-semibold">Profil Ayarları</span>
          </button>
          <button
            className="w-full flex items-center gap-2 px-5 py-3 text-base text-gray-700 hover:bg-gray-100 transition border-t border-gray-100 rounded-b-xl"
            onClick={onLogout}
          >
            Çıkış Yap
          </button>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
